<template>
	<div 
		class="grid-container full">
		<div 
			ref="resultsWrapperInner" 
			aria-live="polite" 
			:class="['grid-x', 'grid-margin-x', 'grid-margin-y', 'initialized', 'dc-post-grid-results-inner', {
				loading: loading
			}]">
			<p v-if="results.length===0">{{ dctxt('noResultsMessage') }}</p>
			<div 
				v-for="(result, index) in results" 
				ref="resultsWrapperInnerAlt"
				:key="'result-' + index" 
				:class="['cell']">
				<default 
					:id="result.id" 
					:title="result.title" 
					:excerpt="result.excerpt" 
					:url="result.url" 
					:image="result.image" 
					:label="result.label" 
					:style="{ zIndex: results.length - index }"
					/>
			</div>
		</div>
		<LoadMore 
			v-if="showLoadMore && !endOfResults && !usesPagination"
			:loading="loading" 
			:currentPaged="currentPaged"
			:searchButtonId="searchButtonId"
			v-on:update-current-paged="updateCurrentPaged" />
		<Pagination 
			v-if="showLoadMore && usesPagination"
			:loading="loading" 
			:currentPaged="currentPaged"
			:totalPages="totalPages" 
			:postNavigationType="postNavigationType"
			v-on:update-current-paged="updateCurrentPaged" />
	</div>
</template>

<script>
import { ref } from 'vue'
import { Translatable } from '@dc-post-grid/mixins/Translatable';
import Default from '@dc-post-grid/layout/cards/Default';
import LoadMore from '@dc-post-grid/layout/ui/LoadMore';
import Pagination from '@dc-post-grid/layout/ui/Pagination';
export default {
	setup() {
		const resultsWrapperInner = ref()
		const resultsWrapperInnerAlt = ref()

		return {
			resultsWrapperInner,
			resultsWrapperInnerAlt,
		}

	},
	mixins: [
		Translatable
	],
	props: {
		loading: {
			type: Boolean,
			required: true
		},
		results: {
			type: Array,
			required: true
		},
		gridLayout: {
			type: String,
			default: 'default',
			required: false
		},
		showLoadMore: {
			type: Boolean,
			default: false,
			required: true
		},
		currentPaged: {
			type: Number,
			required: false,
			default: 0
		},
		totalPosts: {
			type: Number,
			required: false
		},
		totalPages: {
			type: Number,
			required: false
		},
		usesPagination: {
			type: Boolean,
			default: false,
		},
		postNavigationType: {
			type: String,
			default: 'none',
		},
		endOfResults: {
			type: Boolean,
			default: false,
			required: true
		},
		searchButtonId: {
			type: String,
			required: true
		}
	},
	methods: {
		updateCurrentPaged(newPagedNumber) {
			this.$emit('update-current-paged', newPagedNumber)
		}
	},
	components: {
		Default,
		LoadMore,
		Pagination,
	}
}
</script>